module.exports = __webpack_public_path__ + "img/16_50.0c08698d.png";